import { Directive, HostListener, Input } from '@angular/core';
import { MediaViewerService } from '../media-viewer/media-viewer.service';
import { IMediaBankFile, IMediaBankFileReference } from '@fi-shared/media-bank';
import { isDefined } from '@fi-shared/utils';

@Directive({
    selector: '[fiImagePopup]',
    standalone: false,
})
export class ImagePopupDirective {
    @Input() fiImagePopup: string;
    @Input() fiImagePreviewMediaBank: IMediaBankFile;
    @Input() fiImagePreviewMediaBanks: IMediaBankFile[];
    @Input() fiImagePreviewMediaBankReference: IMediaBankFileReference;
    @Input() fiImagePreviewMediaBankReferences: IMediaBankFileReference[];
    @Input() fiImagePreviewDisabled: boolean;

    constructor(private mediaViewerService: MediaViewerService) {}

    @HostListener('click', ['$event'])
    onClick($event: MouseEvent) {
        $event.preventDefault();
        $event.stopPropagation();

        if (this.fiImagePreviewDisabled) return;

        const mediaBankFileReferences: IMediaBankFileReference[] = isDefined(this.fiImagePreviewMediaBankReferences)
            ? this.fiImagePreviewMediaBankReferences
            : [this.fiImagePreviewMediaBankReference];
        const mediaBankFiles: IMediaBankFile[] = isDefined(this.fiImagePreviewMediaBanks)
            ? this.fiImagePreviewMediaBanks
            : [this.fiImagePreviewMediaBank];

        this.mediaViewerService.Show(this.fiImagePopup, mediaBankFiles, mediaBankFileReferences);
    }
}
